import { useTranslation } from 'react-i18next';

import { BtnLine, BtnTeal } from '@quizzach/styles';
import { ModalShell } from '@quizzach/components';

export const PoolExhaustionWarningModal = ({
	show,
	onConfirm,
	onCancel,
	text,
	cancelLabel,
	confirmLabel,
}: {
	show: boolean;
	onConfirm: (confirm: boolean) => void;
	onCancel: () => void;
	text: string;
	cancelLabel?: string;
	confirmLabel?: string;
}) => {
	const { t } = useTranslation();

	return (
		<ModalShell
			show={show}
			onClose={() => onConfirm(false)}
			size='sm'
			center
			actions={
				<>
					<BtnLine $small onClick={onCancel}>
						{cancelLabel ?? t('modal.confirmation.cancel')}
					</BtnLine>
					<BtnTeal $small onClick={() => onConfirm(true)}>
						{confirmLabel ?? t('modal.confirmation.confirm')}
					</BtnTeal>
				</>
			}
		>
			<p style={{ margin: '8px 0 0' }}>{text}</p>
		</ModalShell>
	);
};
